import React from 'react';
import styled from 'styled-components';

const Circle = styled.div`
  background-color: ${({ active }) => active ? '#00687F' : '#86A0B0'};
  border-radius: 100px;
  width: 11.5px;
  height: 11.5px;

  &:not(last-child) {
    margin-right: 0.3rem;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LevelIcon = ({ level }) => {
  const parsedLevel = Array.isArray(level) ? level[0]?.toLowerCase() : level.toLowerCase();

  const levelToNumber = {
    low: 1,
    mid: 2,
    high: 3,
  }[parsedLevel];

  return (
    <Wrapper>
      <Circle  active/>
      <Circle active={levelToNumber === 2 || levelToNumber === 3}/>
      <Circle  active={levelToNumber === 3}/>
    </Wrapper>
  );
};

export default LevelIcon;
